import store from '@/store/store'

class ListModule {

  setHoveredItemId(itemId) {
    store.commit('UI_LIST_HOVERED_ITEM_ID_SET', itemId)
  }

  getHoveredItemId = () => store.state.ui.list.hoveredItemId
}

export default new ListModule()
